import type { Listing } from '@thevillages/schemas';

import type { ListingsService } from '../listings';

export function Garage(this: ListingsService, listing: Listing, currentValue: boolean): boolean {
  // If no value is set, do not affect the filter.
  if (!this.filteringService.garages().length) {
    return currentValue;
  }

  // If the listing does not have a value, exclude it from results.
  if (!listing.garage?.cars) {
    return false;
  }

  // Determine if the listing matches the filter.
  // The filter can include multiple values, so we need to check if the listing matches any of the values.
  const _cars: number[] = [];
  let onlyIncludeGolf = false;
  let onlyIncludeOversized = false;
  for (const _garage of this.filteringService.garages()) {
    switch (_garage) {
      case '1-car':
        _cars.push(1);
        break;
      case '1-car-golf':
        _cars.push(1);
        onlyIncludeGolf = true;
        break;
      case '2-car':
        _cars.push(2);
        break;
      case '2-car-golf':
        _cars.push(2);
        onlyIncludeGolf = true;
        break;
      case '3-car':
        _cars.push(...[3, 4, 5, 6]);
        break;
      case '3-car-golf':
        _cars.push(...[3, 4, 5, 6]);
        onlyIncludeGolf = true;
        break;
      case 'oversized':
        _cars.push(...[1, 2, 3, 4, 5, 6]);
        onlyIncludeOversized = true;
        break;
    }
  }
  if (!_cars.includes(listing.garage.cars)) {
    return false;
  }
  if (onlyIncludeGolf && !listing.garage.golf) {
    return false;
  }
  if (onlyIncludeOversized && !listing.garage.extended) {
    return false;
  }

  // If the listing does not match the filter, do not affect the filter.
  return currentValue;
}
